var _mask, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGym(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    fill: "none",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "jj46e6csma",
    width: 48,
    height: 48,
    x: 1,
    y: 1,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M1 1h48v48H1V1z",
    clipRule: "evenodd"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#jj46e6csma)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6C7281",
    fillRule: "evenodd",
    d: "M44.229 22.046l-2.147 2.146c-.697.696-1.829.697-2.526 0L25.808 10.443c-.696-.696-.696-1.83 0-2.526l2.146-2.146c.696-.697 1.83-.696 2.526 0L44.229 19.52c.695.697.695 1.829 0 2.526zm-23.366 8.947l-2.32-2.32 10.21-10.21 2.32 2.32-10.21 10.21zm3.41 11.01l-2.147 2.146c-.696.695-1.83.696-2.526 0L5.852 30.399c-.696-.696-.696-1.828 0-2.525l2.146-2.146c.696-.696 1.828-.696 2.526 0l13.749 13.748c.696.697.696 1.83 0 2.526zm21.507-25.51c.208-.143.408-.303.593-.488l1.413-1.412c1.504-1.505 1.628-3.83.275-5.182-.633-.633-1.664-.64-2.296-.009-.632.633-.638 1.65-.006 2.282.024.055.02.337-.263.62l-1.413 1.412c-.282.282-.564.287-.602.275l-7.46-7.456c-.024-.054-.02-.336.264-.62l1.411-1.41c.283-.284.566-.289.604-.277l2.979 2.98c.632.632 1.657.632 2.29 0 .632-.633.632-1.657 0-2.29l-2.98-2.98C39.236.586 36.912.71 35.407 2.214l-1.412 1.412c-.185.186-.348.384-.49.59l-.736-.735c-1.958-1.958-5.145-1.957-7.104 0l-2.147 2.147c-1.958 1.96-1.958 5.146 0 7.105l3.193 3.192-.248.248-10.21 10.21-.246.248-3.194-3.194c-1.958-1.957-5.145-1.957-7.105 0l-2.146 2.147c-1.958 1.96-1.958 5.146 0 7.105l.757.756c-.245.16-.48.339-.692.55l-1.413 1.413C.71 36.912.586 39.238 1.94 40.59l1.446 1.445c.632.633 1.657.633 2.29 0 .632-.631.632-1.656 0-2.289l-1.434-1.43c-.025-.054-.02-.337.262-.62l1.413-1.411c.282-.282.564-.285.604-.276l7.459 7.456c.024.054.02.337-.263.62l-1.412 1.411c-.283.283-.566.287-.604.276l-2.018-2.018c-.632-.633-1.657-.633-2.289 0-.633.633-.633 1.657 0 2.29l2.018 2.018c.63.629 1.468.938 2.337.938 1 0 2.04-.41 2.845-1.213l1.412-1.413c.212-.212.39-.447.55-.692l.756.756c.98.98 2.266 1.47 3.552 1.47 1.287 0 2.573-.49 3.553-1.47l2.146-2.147c1.959-1.958 1.959-5.145 0-7.104l-3.656-3.657.248-.248 10.208-10.21.25-.246 3.655 3.656c.98.98 2.266 1.47 3.552 1.47 1.287 0 2.573-.49 3.553-1.47l2.147-2.147c1.957-1.958 1.957-5.146-.001-7.104l-.738-.738z",
    clipRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGym);
export default __webpack_public_path__ + "static/media/gym.cae54eabff92493558c5b8868b7098ab.svg";
export { ForwardRef as ReactComponent };